// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-bubble {
    width: 100%;
}

/* Chart lives on a light "figure" card in both app themes (matches the mermaid
   diagram card) so its dark-on-light axis/grid colors stay legible. */
.chart-message-content {
    background-color: #f4f6f8;
    border: 1px solid rgba(18, 48, 63, 0.14);
    box-shadow: 0 6px 18px rgba(18, 48, 63, 0.07);
    border-radius: 12px;
    padding: 16px 20px;
    min-width: 0;
}

.chart-title {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 12px 0;
    color: #12303f;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChartMessage/ChartMessage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;sEACsE;AACtE;IACI,yBAAyB;IACzB,wCAAwC;IACxC,6CAA6C;IAC7C,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".chart-bubble {\n    width: 100%;\n}\n\n/* Chart lives on a light \"figure\" card in both app themes (matches the mermaid\n   diagram card) so its dark-on-light axis/grid colors stay legible. */\n.chart-message-content {\n    background-color: #f4f6f8;\n    border: 1px solid rgba(18, 48, 63, 0.14);\n    box-shadow: 0 6px 18px rgba(18, 48, 63, 0.07);\n    border-radius: 12px;\n    padding: 16px 20px;\n    min-width: 0;\n}\n\n.chart-title {\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0 0 12px 0;\n    color: #12303f;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
